import appstore from "../../appStore";
import { ServiceCheckStatus } from "../Booking/BookingEntities";
import { Dispatch } from "../Dispatch";
import { ShowDialogSimpleErrorMessage } from "../../widgets/general-error-message/ErrorMessagingHelper";
import { WellKnownMessageKind } from "../Utils/ErrorMessages";
import { ApiVehicleOption, DataLoadingStatus, VehicleOption } from "./Redux/ConditionEntities";
import { ParseVehicleConditionHelper } from "./ConditionHelper";
import { FeatureFlags } from "../../Config/FeatureFlags";
import { MakeVehicleLookupFromApiData } from "./ConditionHelperV2";
import { BookingFormKind } from "../UILogicControl/UILogicControlEntities";

/** Called on click of the vehicle selector section. Set the default set of vehicles if the address is empty. */
export async function listConditionsWithFareByPickUp() {

    const appState = appstore.getState();
    const bookingPayload = appState.booking;
    const activeBookingForm = appState.uiLogicControl.BookingForm.ActiveBookingForm;

    // if the booking form selected is parcel booking return early. (The vehicle selector section will not be visible for selecting vehicles other than parcel)
    if (activeBookingForm === BookingFormKind.ParcelBooking)
    {
        return;
    }

    // pickup valid?
    const pickupCheckStatus = bookingPayload.PickupServiceCheck.status;

    // pickup defined?
    if (!bookingPayload.Locations[0].Address && pickupCheckStatus === ServiceCheckStatus.NoInputSelected) {

        // Populate the default services list when there is no pickup address specified.
        PopulateConditionListWithDefaultVehicles();

        return;
    }

    if ((pickupCheckStatus === ServiceCheckStatus.Error) || (pickupCheckStatus === ServiceCheckStatus.KnownBad)) {
        ShowDialogSimpleErrorMessage(WellKnownMessageKind.NoPickupForCondition);
        return;
    }

}

// Default vehicle condition list to be displayed for booking template (V1 API)
export const vehicleConditionList: ApiVehicleOption[] = [
    { "ApiId": 3, "Name": "Silver Service", "MaxSeat": 4, "Description": "up to 4 passengers", ApiVersion: 1 },
    { "ApiId": 4, "Name": "Silver Service Exec", "MaxSeat": 4, "Description": "up to 4 passengers", ApiVersion: 1 },
    { "ApiId": 5, "Name": "Silver Service Exec XL", "MaxSeat": 11, "Description": "up to 11 passengers", ApiVersion: 1 },
    { "ApiId": 6, "Name": "Parcels", "MaxSeat": 4, "Description": "Parcels", ApiVersion: 1 },
    { "ApiId": 12, "Name": "Sedan", "MaxSeat": 4, "Description": "up to 4 passengers", ApiVersion: 1 },
    { "ApiId": 14, "Name": "1 Wheelchair", "MaxSeat": 1, "Description": "accessible taxi", ApiVersion: 1 },
    { "ApiId": 16, "Name": "MAXI TAXI", "MaxSeat": 6, "Description": "6 seats", ApiVersion: 1 },
    { "ApiId": 17, "Name": "MAXI TAXI", "MaxSeat": 7, "Description": "7 seats", ApiVersion: 1 },
    { "ApiId": 18, "Name": "MAXI TAXI", "MaxSeat": 8, "Description": "8 seats", ApiVersion: 1 },
    { "ApiId": 19, "Name": "MAXI TAXI", "MaxSeat": 9, "Description": "9 seats", ApiVersion: 1 },
    { "ApiId": 20, "Name": "MAXI TAXI", "MaxSeat": 10, "Description": "10 seats", ApiVersion: 1 },
    { "ApiId": 21, "Name": "MAXI TAXI", "MaxSeat": 11, "Description": "11 seats", ApiVersion: 1 },
    { "ApiId": 26, "Name": "MAXI TAXI", "MaxSeat": 5, "Description": "5 seats", ApiVersion: 1 },
    { "ApiId": 101, "Name": "MAXI TAXI", "MaxSeat": 1, "Description": "1 seats", ApiVersion: 1 },
    { "ApiId": 102, "Name": "MAXI TAXI", "MaxSeat": 2, "Description": "2 seats", ApiVersion: 1 },
    { "ApiId": 103, "Name": "MAXI TAXI", "MaxSeat": 3, "Description": "3 seats", ApiVersion: 1 },
    { "ApiId": 104, "Name": "MAXI TAXI", "MaxSeat": 4, "Description": "4 seats", ApiVersion: 1 }
];

// Default vehicle condition list for BookingApiV2 (V2 TaxiServiceIds)
export const vehicleConditionListV2: ApiVehicleOption[] = [
    { "ApiId": 2, "Name": "Sedan", "MaxSeat": 4, "Description": "up to 4 passengers", ApiVersion: 2 },
    { "ApiId": 4, "Name": "SilverService", "MaxSeat": 4, "Description": "up to 4 passengers", ApiVersion: 2 },
    { "ApiId": 5, "Name": "MaxiTaxi", "MaxSeat": 11, "Description": "up to 11 passengers", ApiVersion: 2 },
    // { "ApiId": 9, "Name": "SilverServiceExec", "MaxSeat": 4, "Description": "up to 4 passengers", ApiVersion: 2 },
    // { "ApiId": 10, "Name": "SilverServiceExecXl", "MaxSeat": 7, "Description": "up to 7 passengers", ApiVersion: 2 },
    { "ApiId": 11, "Name": "Wheelchair", "MaxSeat": 1, "Description": "accessible taxi", ApiVersion: 2 },
    { "ApiId": 12, "Name": "Parcel", "MaxSeat": 0, "Description": "Parcel delivery", ApiVersion: 2 }
];

/** Populates the default condition list in the store (V1 or V2 based on feature flag) */
export function PopulateConditionListWithDefaultVehicles() {
    
    if (FeatureFlags.BookingApiV2) {
        // V2: Use TaxiServiceIds
        const parsedLookupTables = ParseVehicleConditionHelper(vehicleConditionListV2);
        Dispatch.Condition.RefreshConditions(parsedLookupTables);
        Dispatch.Condition.ConditionDataLoadStatus({ Status: DataLoadingStatus.Idle, LastInput: null });
        ConsiderPopulateDefaultVehicle(appstore.getState().condition.ConditionList);
    } else if(FeatureFlags.GlobalBooker) {
        PopulateConditionListWithDefaultVehiclesGlobalBooker();
    } else {
        // V1: Use ConditionIds
        Dispatch.Condition.LoadAllRawV1Data(vehicleConditionList);

        // Retrieve metainfo
        const parsedLookupTables = ParseVehicleConditionHelper(vehicleConditionList);

        // Update the vehicle condition list in store
        Dispatch.Condition.RefreshConditions(parsedLookupTables);
 
        // Clear the suburbId   
        Dispatch.Condition.ConditionDataLoadStatus({ Status: DataLoadingStatus.Idle, LastInput: null });
    }
}

/** Populates the default condition list in the store for GB */
export function PopulateConditionListWithDefaultVehiclesGlobalBooker() {
    // Retrieve metainfo
    const parsedLookupTables = MakeVehicleLookupFromApiData(null);

    // Update the condition list in store
    Dispatch.Condition.RefreshConditionsV2(parsedLookupTables);

    // Clear the suburbId   
    Dispatch.Condition.ConditionDataLoadStatus({ Status: DataLoadingStatus.Idle, LastInput: null });

    ConsiderPopulateDefaultVehicle(appstore.getState().condition.ConditionList);
}

/** If a vehicle is not selected already, make the brand's primary vehicle the selected vehicle. */
export function ConsiderPopulateDefaultVehicle(vehicles: VehicleOption[]) {
    if (vehicles.length == 0) return;

    const selectedVehicle = appstore.getState().condition.SelectedCondition;

    // In initial state of store.Condition, Next Available (in which ApiVehicle is undefined) is defined as selected condition.
    // This if statement makes sure the SelectedCondition is an actual user selected vehicle and if not, proceed to replace with the brand's default vehicle.
    if (selectedVehicle.ApiVehicle) return;

    // select brand's primary vehicle by default.
    const defaultVehicle = vehicles.find(i => i.Service.IsDefault) || vehicles[0];
    Dispatch.Condition.SelectVehicle(defaultVehicle);
}
